export default "__VITE_ASSET__BtclYQo5__"